import { LOTTIE_VISUAL } from '../elements/lottie'
import { ASSET_MOBILE, ASSET_DESKTOP } from '../elements/assets'
import { BUTTON } from '../elements/link'
import { CONVERSATION_BOX } from '../elements/conversationBox'

export const OVERSIGHT_SHOWCASE = `
...on oversightShowcase_Entry {
  ${ LOTTIE_VISUAL }
  id
  typeHandle
  anchorId

  heading: headingAdvanced {
    html
  }
  ${ BUTTON }
  
  positionOversightShowcase

  ${ ASSET_MOBILE }
  ${ ASSET_DESKTOP }
  ${ CONVERSATION_BOX }

  oversightShowcaseItems {
    id
    linkField {url}
    title
    description
    icon: iconField {
      url
      title
    }
  }

}
`
